//  https://github.com/piersrueb/inViewport
document.addEventListener('DOMContentLoaded', function () {

  const inViewport = (elem) => {
    let allElements = document.getElementsByClassName(elem);
    let windowHeight = window.innerHeight;
    const elems = () => {
      for (let i = 0; i < allElements.length; i++) { //  loop through the sections
        let viewportOffset = allElements[i].getBoundingClientRect(); //  returns the size of an element and its position relative to the viewport
        let top = viewportOffset.top; //  get the offset top
        if (top < windowHeight) { //  if the top offset is less than the window height
          allElements[i].classList.add('in-viewport'); //  add the class
        } else {
          allElements[i].classList.remove('in-viewport'); //  remove the class
        }
      }
    }
    elems();
    window.addEventListener('scroll', elems);
  }

  inViewport('animate-this'); //  run the function on all section elements

  /*
    var tables = document.querySelectorAll('.specialReportsV2 .copy-block-content table');
    tables.forEach(function(table) {
      var wrapper = document.createElement('div');
      wrapper.className = 'table-responsive';
      table.parentNode.replaceChild(wrapper, table);
      wrapper.appendChild(table);
    });
    */
  // Select all tables inside .bc-special-reports > .copy-block-content
  var tables = document.querySelectorAll('.specialReportsV2 .copy-block-content table');

  // Select all tables inside .specialReportsV2 .slideOut__content_copy
  var tablesSlideOut = document.querySelectorAll('.specialReportsV2 .slideOut__content_copy table');

  // Function to add a div.table-responsive wrapper to tables
  function addTableResponsiveWrapper(tables) {
    tables.forEach(function (table) {
      var wrapper = document.createElement('div');
      wrapper.className = 'table-responsive';
      table.parentNode.replaceChild(wrapper, table);
      wrapper.appendChild(table);
    });
  }

  // Add wrapper to tables selected from the first selector
  addTableResponsiveWrapper(tables);

  // Add wrapper to tables selected from the second selector
  addTableResponsiveWrapper(tablesSlideOut);


});
